import type { Flare } from "@flareapp/js";
import { redact, sanitizePageUrl } from "@smakecloud/browser-telemetry";

// @flareapp/js does not export its Report type
type Report = Parameters<Flare["beforeSubmit"]>[0];

// reports nest deeper than redact()'s default of 8 (context groups, glows' meta_data)
const FLARE_REDACT_DEPTH = 16;

/**
 * Flare beforeSubmit with the shared redaction rules (the same as Faro and Alloy): sensitive keys
 * lose their value, strings go through the rules (/entrance?t=…&r=…, Bearer, JWTs, email=, …).
 * The parsed query (Flare's url.query) is rebuilt from the sanitized URL, so /entrance's refresh
 * token does not slip through as a plain value.
 */
export function redactFlareReport(report: Report): Report {
    const redacted = redact(
        { ...report, application_path: report.context.request?.url },
        { maxDepth: FLARE_REDACT_DEPTH },
    );
    const request = redacted.context.request;

    if (!request?.url) {
        return redacted;
    }

    const url = sanitizePageUrl(String(request.url));

    request.url = url;
    redacted.application_path = url;

    if (redacted.context.request_data) {
        redacted.context.request_data.queryString = queryString(url);
    }

    return redacted;
}

function queryString(url: string): Record<string, string> {
    try {
        return Object.fromEntries(new URL(url).searchParams);
    } catch {
        return {};
    }
}
